// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

import Animation from "./Animation.js";

export default class SkillsAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.cards = this.element.querySelectorAll(".card");

    gsap.set(this.cards, { yPercent: 100, opacity: 0 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.cards, {
      opacity: 1,
      yPercent: 0,
      duration: 1,
      stagger: 0.1,
      ease: "back.out(1.2)",
    });

    return tl;
  }
}
